const CUSTOMER_LIST_SUCCESS = "CUSTOMER_LIST_SUCCESS";
const CUSTOMER_LIST_FAIL = "CUSTOMER_LIST_FAIL";
const CUSTOMER_CREATE_SUCCESS = "CUSTOMER_CREATE_SUCCESS";
const CUSTOMER_CREATE_FAIL = "CUSTOMER_CREATE_FAIL";
const CUSTOMER_CREATE_RESET = "CUSTOMER_CREATE_RESET";
const CUSTOMER_SELECTED_SUCCESS = "CUSTOMER_SELECTED_SUCCESS";
const CUSTOMER_SELECTED_FAIL = "CUSTOMER_SELECTED_FAIL";
const CUSTOMER_LOADED = "CUSTOMER_LOADED";
const CUSTOMER_UPDATE_SUCCESS = "CUSTOMER_UPDATE_SUCCESS";
const CUSTOMER_UPDATE_FAIL = "CUSTOMER_UPDATE_FAIL";
const CUSTOMER_GET_SUCCESS = "CUSTOMER_GET_SUCCESS";
const CUSTOMER_GET_FAIL = "CUSTOMER_GET_FAIL";
const CUSTOMER_DELETE_SUCCESS = "CUSTOMER_DELETE_SUCCESS";
const CUSTOMER_DELETE_FAIL = "CUSTOMER_DELETE_FAIL";
const CUSTOMER_TARGET4_GET_SUCCESS = "CUSTOMER_TARGET4_GET_SUCCESS";
const CUSTOMER_TARGET4_GET_FAIL = "CUSTOMER_TARGET4_GET_FAIL";
const CUSTOMER_TARGET6_GET_SUCCESS = "CUSTOMER_TARGET6_GET_SUCCESS";
const CUSTOMER_TARGET6_GET_FAIL = "CUSTOMER_TARGET6_GET_FAIL";
const CUSTOMER_TARGET4_UPDATE_SUCCESS = "CUSTOMER_TARGET4_UPDATE_SUCCESS";
const CUSTOMER_TARGET4_UPDATE_FAIL = "CUSTOMER_TARGET4_UPDATE_FAIL";
const CUSTOMER_TARGET6_UPDATE_SUCCESS = "CUSTOMER_TARGET6_UPDATE_SUCCESS";
const CUSTOMER_TARGET6_UPDATE_FAIL = "CUSTOMER_TARGET6_UPDATE_FAIL";
const CUSTOMER_TARGET4_RESET = "CUSTOMER_TARGET4_RESET";
const CUSTOMER_TARGET6_RESET = "CUSTOMER_TARGET6_RESET";
const CUSTOMER_GET_POELOAD_SUCCESS = "CUSTOMER_GET_POELOAD_SUCCESS";
const CUSTOMER_GET_POELOAD_FAIL = "CUSTOMER_GET_POELOAD_FAIL";
const CUSTOMER_UPDATE_POELOAD_SUCCESS = "CUSTOMER_UPDATE_POELOAD_SUCCESS";
const CUSTOMER_UPDATE_POELOAD_FAIL = "CUSTOMER_UPDATE_POELOAD_FAIL";
const COUNTRY_STATE_LIST_SUCCESS = 'COUNTRY_STATE_LIST_SUCCESS'
const COUNTRY_STATE_LIST_FAIL= "COUNTRY_STATE_LIST_FAIL"
const CUSTOMER_ACCEPT_LOCATION_TRACKING_SUCCESS = "CUSTOMER_ACCEPT_LOCATION_TRACKING_SUCCESS"
const CUSTOMER_ACCEPT_LOCATION_TRACKING_FAIL = "CUSTOMER_ACCEPT_LOCATION_TRACKING_FAIL"
const CUSTOMER_CANCEL_LOCATION_TRACKING_SUCCESS = "CUSTOMER_CANCEL_LOCATION_TRACKING_SUCCESS"
const CUSTOMER_CANCEL_LOCATION_TRACKING_FAIL = "CUSTOMER_CANCEL_LOCATION_TRACKING_FAIL"

export const defaultCustomerState = {
  error: false,
  created: false,
  updated: false,
  customer: null,
  customers: null,
  customerId: null,
  errorMessage: null,
  countryStates: null
};

export default (state = defaultCustomerState, action) => {
  switch (action.type) {
    case CUSTOMER_LIST_SUCCESS:
      return {
        ...state,
        customers: action.payload.data
        // customer: action.meta.previousAction.payload.request.customer
      };
    case CUSTOMER_LIST_FAIL:
      return {
        ...state,
        customers: null
      };
    case CUSTOMER_CREATE_SUCCESS: {
      if (action.payload.data.success) {
        return {
          ...state,
          created: true,
          customer: action.meta.previousAction.payload.request.data.request,
          customerId: action.payload.data.id,
          error: false
        };
      } else {
        return {
          ...state,
          errorMessage: action.payload.data.errors,
          created: false,
          error: true
        };
      }
    }
    case CUSTOMER_CREATE_FAIL:
      return {
        ...state,
        created: false,
        error: true,
        errorMessage: action.error.response.statusText
      };
    case CUSTOMER_CREATE_RESET:
      return {
        ...state,
        created: false,
        customer: null,
        customerId: null,
        error: false
      };
    case CUSTOMER_SELECTED_SUCCESS:
      return {
        ...state,
        created: false,
        customer: action.payload.data,
        customerId: action.payload.data.id,
        error: false
      };
    case CUSTOMER_SELECTED_FAIL:
      return {
        ...state,
        created: false,
        error: true,
        errorMessage: action.error.response.statusText
      };
    case CUSTOMER_LOADED: {
      return {
        ...state,
        created: false,
        customer: action.data.customer,
        customerId: action.data.customer.id,
        error: false
      };
    }

    case CUSTOMER_UPDATE_SUCCESS: {
      if (action.payload.data.success) {
        return {
          ...state,
          updated: true,
          customerId: action.payload.data.id,
          error: false
        };
      } else {
        return {
          ...state,
          errorMessage: action.payload.data.errors,
          updated: false,
          error: true
        };
      }
    }

    case CUSTOMER_UPDATE_FAIL: {
      return {
        ...state,
        updated: false,
        error: true,
        errorMessage: action.error.response.statusText
      };
    }

    case CUSTOMER_GET_SUCCESS: {
      return {
        ...state,
        customer: action.payload.data,
        customerId: action.payload.data.id
      };
    }
    case CUSTOMER_GET_FAIL: {
      return {
        ...state,
        error: true,
        errorMessage: action.error.response.statusText
      };
    }
    case CUSTOMER_DELETE_SUCCESS: {
      return {
        ...state
      };
    }
    case CUSTOMER_DELETE_FAIL: {
      return {
        ...state
      };
    }
    case CUSTOMER_TARGET4_GET_SUCCESS: {
      return {
        ...state,
        customerTargets4: action.payload.data
      };
    }
    case CUSTOMER_TARGET4_GET_FAIL: {
      return {
        ...state,
        error: true,
        errorMessage: action.error.response.statusText
      };
    }
    case CUSTOMER_TARGET6_GET_SUCCESS: {
      return {
        ...state,
        customerTargets6: action.payload.data
      };
    }
    case CUSTOMER_TARGET6_GET_FAIL: {
      return {
        ...state,
        error: true,
        errorMessage: action.error.response.statusText
      };
    }
    case CUSTOMER_TARGET4_UPDATE_SUCCESS: {
      if (action.payload.data.success) {
        return {
          ...state,
          updated: true,
          error: false
        };
      } else {
        return {
          ...state,
          errorMessage: action.payload.data.errors,
          updated: false,
          error: true
        };
      }
    }
    case CUSTOMER_TARGET4_UPDATE_FAIL: {
      return {
        ...state,
        error: true,
        errorMessage: action.error.response.statusText
      };
    }
    case CUSTOMER_TARGET6_UPDATE_SUCCESS: {
      if (action.payload.data.success) {
        return {
          ...state,
          updated: true,
          error: false
        };
      } else {
        return {
          ...state,
          errorMessage: action.payload.data.errors,
          updated: false,
          error: true
        };
      }
    }
    case CUSTOMER_TARGET6_UPDATE_FAIL: {
      return {
        ...state,
        error: true,
        errorMessage: action.error.response.statusText
      };
    }
    case CUSTOMER_TARGET4_RESET:
      return {
        ...state,
        customerTargets4: null
      };
    case CUSTOMER_TARGET6_RESET:
      return {
        ...state,
        customerTargets6: null
      };
    case CUSTOMER_GET_POELOAD_SUCCESS:
      return {
        ...state,
        customerPoELoad : action.payload.data
      };
    case CUSTOMER_GET_POELOAD_FAIL:
      return {
        ...state,
        error: true,
        errorMessage: action.error.response.statusText
      };
    case CUSTOMER_UPDATE_POELOAD_SUCCESS:{
      if (action.payload.data.success) {
        return {
          ...state,
          updated: true,
          error: false
        };
      } else {
        return {
          ...state,
          errorMessage: action.payload.data.errors,
          updated: false,
          error: true
        };
      }
    }
    case CUSTOMER_UPDATE_POELOAD_FAIL : {
      return {
        ...state,
        error: true,
        errorMessage: action.error.response.statusText
      };
    }
    case COUNTRY_STATE_LIST_SUCCESS: {
      const countryStateList = action.payload.data
      return {
        ...state,
        countryStates: countryStateList
      }
    }
    case COUNTRY_STATE_LIST_FAIL: {
      return {
        ...state,
        error: true,
        errorMessage: action.error.response.statusText
      }
    }
    case CUSTOMER_ACCEPT_LOCATION_TRACKING_SUCCESS:
      return {
        ...state,
      };
    case CUSTOMER_ACCEPT_LOCATION_TRACKING_FAIL:
      return {
        ...state,
        error: true,
        errorMessage: action.error.response.statusText
      };
    case CUSTOMER_CANCEL_LOCATION_TRACKING_SUCCESS:
      return {
        ...state,
      };
    case CUSTOMER_CANCEL_LOCATION_TRACKING_FAIL:
      return {
        ...state,
        error: true,
        errorMessage: action.error.response.statusText
      };
    default:
      return state;
  }
};
